// Type definition for color schemes
export type ColorScheme = 'scheme1' | 'scheme2' | 'scheme3' | 'scheme4' | 'scheme5' | 'scheme6';
export type IconColor = ColorScheme | 'whatsapp' | 'linkedin' | 'github';

// Color configuration for each variant
export const ColorConfig = {
  scheme1: {
    text: 'var(--scheme1-text)',
    background: 'var(--scheme1-background)',
    border: 'var(--scheme1-border-default)',
    borderAccent: 'var(--scheme1-border-accent)',
    shadow: 'var(--scheme1-shadow-default)',
    hoverText: 'var(--scheme1-hover-text)',
    hoverBackground: 'var(--scheme1-hover-background)',
    hoverBorder: 'var(--scheme1-hover-border)',
    activeText: 'var(--scheme1-active-text)',
    activeBackground: 'var(--scheme1-active-background)',
    activeBorder: 'var(--scheme1-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme1-input-background)',
    inputBorder: 'var(--scheme1-input-border)',
    inputColor: 'var(--scheme1-input-color)',
    inputPlaceholder: 'var(--scheme1-input-placeholder)',
    inputFocusBorder: 'var(--scheme1-input-focus-border)',
    inputFocusShadow: 'var(--scheme1-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme1-input-autofill-background)',
    inputAutofillColor: 'var(--scheme1-input-autofill-color)',
  },
  scheme2: {
    text: 'var(--scheme2-text)',
    background: 'var(--scheme2-background)',
    border: 'var(--scheme2-border-default)',
    borderAccent: 'var(--scheme2-border-accent)',
    shadow: 'var(--scheme2-shadow-default)',
    hoverText: 'var(--scheme2-hover-text)',
    hoverBackground: 'var(--scheme2-hover-background)',
    hoverBorder: 'var(--scheme2-hover-border)',
    activeText: 'var(--scheme2-active-text)',
    activeBackground: 'var(--scheme2-active-background)',
    activeBorder: 'var(--scheme2-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme2-input-background)',
    inputBorder: 'var(--scheme2-input-border)',
    inputColor: 'var(--scheme2-input-color)',
    inputPlaceholder: 'var(--scheme2-input-placeholder)',
    inputFocusBorder: 'var(--scheme2-input-focus-border)',
    inputFocusShadow: 'var(--scheme2-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme2-input-autofill-background)',
    inputAutofillColor: 'var(--scheme2-input-autofill-color)',
  },
  scheme3: {
    text: 'var(--scheme3-text)',
    background: 'var(--scheme3-background)',
    border: 'var(--scheme3-border-default)',
    borderAccent: 'var(--scheme3-border-accent)',
    shadow: 'var(--scheme3-shadow-default)',
    hoverText: 'var(--scheme3-hover-text)',
    hoverBackground: 'var(--scheme3-hover-background)',
    hoverBorder: 'var(--scheme3-hover-border)',
    activeText: 'var(--scheme3-active-text)',
    activeBackground: 'var(--scheme3-active-background)',
    activeBorder: 'var(--scheme3-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme3-input-background)',
    inputBorder: 'var(--scheme3-input-border)',
    inputColor: 'var(--scheme3-input-color)',
    inputPlaceholder: 'var(--scheme3-input-placeholder)',
    inputFocusBorder: 'var(--scheme3-input-focus-border)',
    inputFocusShadow: 'var(--scheme3-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme3-input-autofill-background)',
    inputAutofillColor: 'var(--scheme3-input-autofill-color)',
  },
  scheme4: {
    text: 'var(--scheme4-text)',
    background: 'var(--scheme4-background)',
    border: 'var(--scheme4-border-default)',
    borderAccent: 'var(--scheme4-border-accent)',
    shadow: 'var(--scheme4-shadow-default)',
    hoverText: 'var(--scheme4-hover-text)',
    hoverBackground: 'var(--scheme4-hover-background)',
    hoverBorder: 'var(--scheme4-hover-border)',
    activeText: 'var(--scheme4-active-text)',
    activeBackground: 'var(--scheme4-active-background)',
    activeBorder: 'var(--scheme4-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme4-input-background)',
    inputBorder: 'var(--scheme4-input-border)',
    inputColor: 'var(--scheme4-input-color)',
    inputPlaceholder: 'var(--scheme4-input-placeholder)',
    inputFocusBorder: 'var(--scheme4-input-focus-border)',
    inputFocusShadow: 'var(--scheme4-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme4-input-autofill-background)',
    inputAutofillColor: 'var(--scheme4-input-autofill-color)',
  },
  scheme5: {
    text: 'var(--scheme5-text)',
    background: 'var(--scheme5-background)',
    border: 'var(--scheme5-border-default)',
    borderAccent: 'var(--scheme5-border-accent)',
    shadow: 'var(--scheme5-shadow-default)',
    hoverText: 'var(--scheme5-hover-text)',
    hoverBackground: 'var(--scheme5-hover-background)',
    hoverBorder: 'var(--scheme5-hover-border)',
    activeText: 'var(--scheme5-active-text)',
    activeBackground: 'var(--scheme5-active-background)',
    activeBorder: 'var(--scheme5-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme5-input-background)',
    inputBorder: 'var(--scheme5-input-border)',
    inputColor: 'var(--scheme5-input-color)',
    inputPlaceholder: 'var(--scheme5-input-placeholder)',
    inputFocusBorder: 'var(--scheme5-input-focus-border)',
    inputFocusShadow: 'var(--scheme5-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme5-input-autofill-background)',
    inputAutofillColor: 'var(--scheme5-input-autofill-color)',
  },
  scheme6: {
    text: 'var(--scheme6-text)',
    background: 'var(--scheme6-background)',
    border: 'var(--scheme6-border-default)',
    borderAccent: 'var(--scheme6-border-accent)',
    shadow: 'var(--scheme6-shadow-default)',
    hoverText: 'var(--scheme6-hover-text)',
    hoverBackground: 'var(--scheme6-hover-background)',
    hoverBorder: 'var(--scheme6-hover-border)',
    activeText: 'var(--scheme6-active-text)',
    activeBackground: 'var(--scheme6-active-background)',
    activeBorder: 'var(--scheme6-active-border)',
    // Input-specific styles
    inputBackground: 'var(--scheme6-input-background)',
    inputBorder: 'var(--scheme6-input-border)',
    inputColor: 'var(--scheme6-input-color)',
    inputPlaceholder: 'var(--scheme6-input-placeholder)',
    inputFocusBorder: 'var(--scheme6-input-focus-border)',
    inputFocusShadow: 'var(--scheme6-input-focus-shadow)',
    inputAutofillBackground: 'var(--scheme6-input-autofill-background)',
    inputAutofillColor: 'var(--scheme6-input-autofill-color)',
  },
  whatsapp: {
    text: 'var(--color-whatsapp)',
    hoverText: 'var(--color-whatsapp)',
    activeText: 'var(--color-whatsapp)',
  },
  linkedin: {
    text: 'var(--color-linkedin)',
    hoverText: 'var(--color-linkedin)',
    activeText: 'var(--color-linkedin)',
  },
  github: {
    text: 'var(--color-github)',
    hoverText: 'var(--color-github)',
    activeText: 'var(--color-github)',
  },
};
